<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-4 col-md-12">
        <div
          v-tooltip.right="'Back to platform'"
          class="back-to-car-icon"
          @click="navigateToCentralAnalytics"
        >
          <v-icon class="back-to-car-icon-v" style="color: white"
            >arrow_back</v-icon
          >
        </div>
      </div>
    </div>
    <div class="container" style="margin-top: 5px; max-width: 558px">
      <!-- <h1 class="text-xs-center" style="font-weight: bold">
        Welcome to the MSDAT Dashboard
      </h1>
      <p class="text-center" v-if="$route.query.redirect">
        <small style="color:teal">Login first to view a dashboard for your location.</small>
      </p>
      <div>
        <img class="img-center img-circle img-reponsive" src="static/img/login_logo.png"
        style="display: block; margin: 0 auto;" alt="Coat Of Arms">
      </div>-->
      <h2 class="text-center">Contact Us</h2>
      <div
        align="center"
        style="font-weight: 500; font-size: 14.5px; color: #232323"
      >
        <p>
          Welcome to the Multi-Source Data Analytics & Triangulation (MSDAT)
          <br />Platform. The DHPRS Team welcomes your feedback and suggestions.
        </p>
        <p
          align="center"
          style="
            font-weight: 800;
            font-size: 13.5px;
            color: #717171;
            margin-bottom: 15px;
          "
        >
          Please leave us your feedback and we will be in touch soon.
        </p>
      </div>
      <div class="row" style="max-width: 558px">
        <div class="col">
          <form v-on:submit.prevent="conformSend()">
            <div class>
              <div class>
                <p v-show="nofields" class="alert alert-warning">
                  The following fields are required Name, Email Address and
                  Profession
                </p>
                <p
                  align="center"
                  v-show="successmessage"
                  class="alert alert-success"
                >
                  Thank you for contacting us
                </p>
                <p v-show="errormessage" class="alert alert-danger">
                  An error occured, please try again later
                </p>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Name *"
                    required
                    minlength="4"
                    v-model="contactFormFields.name"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Email address *"
                    required
                    email
                    v-model="contactFormFields.email"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Profession or Field or Work/Study *"
                    required
                    v-model="contactFormFields.profession"
                  />
                </div>
                <div class="form-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Organization"
                    v-model="contactFormFields.organization"
                  />
                </div>
                <div class="form-group">
                  <select
                    required
                    class="form-control"
                    v-model="contactFormFields.category"
                  >
                    <option value>Select a Category *</option>
                    <option value="Suggestions">Suggestions</option>
                    <option value="Complaints">Complaints</option>
                    <option value="Ideas">Ideas</option>
                    <option value="General Feedback">General Feedback</option>
                  </select>
                </div>
                <div class="form-group">
                  <textarea
                    required
                    class="form-control"
                    placeholder="Type your feedback..."
                    v-model="contactFormFields.feedback"
                    rows="4"
                  >
feedback</textarea
                  >
                </div>

                <div align="center">
                  <p
                    align="center"
                    v-show="loader"
                    class="animated preFadeInUp fadeInUp"
                  >
                    <img
                      src="static/img/ajax-loader.gif"
                      style="height: 100px"
                    />
                  </p>
                  <button
                    class="btn"
                    style="
                      background-color: #007d53;
                      color: white;
                      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.4);
                      border-color: #007d53;
                      width: 127.5px;
                      height: 41px;
                    "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import auth from './auth'
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      nofields: false,
      loader: false,
      successmessage: false,
      errormessage: false,
      contactFormFields: {
        name: "",
        email: "",
        profession: "",
        organization: "",
        newsletter: false,
        category: "",
        feedback: "",
      },
      error: false,
    };
  },
  methods: {
    validFields: function (field) {
      var re = /(.*[a-z]){3}/i;
      return re.test(field);
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    conformSend() {
      // this.loader = true;
      const headers = {
        Authorization: "Bearer 054d817a3b1a3a2c5edf656959334969e1264e84",
      };
      if (
        this.validFields(this.contactFormFields.name) &&
        this.validFields(this.contactFormFields.profession) &&
        this.validEmail(this.contactFormFields.email) &&
        this.validFields(this.contactFormFields.feedback)
        // this.contactFormFields.name != "" ||
        // this.contactFormFields.email != "" ||
        // this.contactFormFields.profession != ""
      ) {
        this.loader = true;
        this.errormessage = false;
        if (
          this.contactFormFields.name &&
          this.contactFormFields.email &&
          this.contactFormFields.profession &&
          this.contactFormFields.category
        ) {
          axios
            .post(
              "http://135.181.212.168:9234/api/account/contact/",
              this.contactFormFields,
              { headers }
            )
            .then((response) => {
              console.log(this.apiFormat(this.contactFormFields));

              if (response.status === 201) {
                this.successmessage = true;
                this.loader = false;
                this.contactFormFields.name = "";
                this.contactFormFields.email = "";
                this.contactFormFields.profession = "";
                this.contactFormFields.newsletter = false;
                this.contactFormFields.organization = "";
                this.contactFormFields.feedback = "";
                this.contactFormFields.category = "";
              } else {
                this.loader = false;
                this.errormessage = true;
              }
            })
            .catch((e) => {
              console.log(e);
              this.errormessage = true;
              this.loader = false;
            });
          // console.log("testing form");
        }
      } else {
        this.nofields = true;
      }
    },
    apiFormat(value) {
      var parentArray = [];
      var childArray = [];
      childArray.push(
        value.name,
        value.email,
        value.profession,
        value.organization,
        value.category,
        value.feedback,
        value.newsletter
      );
      parentArray.push(childArray);
      return JSON.stringify({ data: parentArray });
    },

    navigateToCentralAnalytics() {
      this.$router.push("central_analytics");
    },
  },
};
</script>

<style>
.error {
  color: red;
}

.back-to-car-icon {
  top: 105px;
}
</style>



// WEBPACK FOOTER //
// contact.vue?5ff41512